import { IconProps } from '@sweep-io/sweep-design/dist/icons/common';
import { ReactNode } from 'react';

export enum PaywallState {
  CUSTOMER = 'CUSTOMER',
  PRE_TRIAL = 'PRE_TRIAL',
  IN_TRIAL = 'IN_TRIAL',
  TRIAL_EXPIRED = 'TRIAL_EXPIRED',
}

export type ActionPaywallItemData = {
  Icon?: React.FunctionComponent<IconProps>;
  header: string;
  subHeader: ReactNode;
  cta: string;
  imageVertical?: ReactNode;
  imageVerticalWide?: ReactNode;
};

//sourced that are NOT full page blocks
export enum ActionPaywallSource {
  DEPENDENCIES = 'dependencies_custom_object',
  FUNNEL_DEPLOY = 'deploy_funnel',
  DOWNLOAD_CSV = 'download_csv',
  AUTO = 'auto',
  AI_CHAT = 'ai_chat',
  ASSIGNMENT_RULES = 'assignment_rules',
  AUTOMATIONS = 'automations',
  ALERTS = 'alerts',
}

export type PaywallBlockProps = { source: ActionPaywallSource; objectName?: string };
